import { CameraGroup } from '@hakimo-ui/hakimo/types';
import { Checkbox } from '@hakimo-ui/shared/ui-base';
import clsx from 'clsx';

interface Props {
  group: CameraGroup;
  checked: boolean;
  // Omitted for the drag preview, which is not interactive.
  onToggle?: (e: React.MouseEvent) => void;
}

const rowClassName =
  'flex w-full items-center gap-4 rounded-xl p-3 text-left outline-none';

const stateClassName = (checked: boolean) =>
  checked
    ? 'bg-onlight-bg-3/50 dark:bg-ondark-bg-3/50'
    : 'hover:bg-onlight-bg-3/50 dark:hover:bg-ondark-bg-3/50';

export function MultiCamCameraGroupRow({ group, checked, onToggle }: Props) {
  const content = (
    <>
      <span className="pointer-events-none flex-none">
        <Checkbox checked={checked} />
      </span>
      <div className="min-w-0 flex-1">
        <div className="dark:text-dark-text text-onlight-text-1 truncate text-sm font-medium">
          {group.name}
        </div>
        <div className="flex items-end justify-between gap-2 leading-tight">
          <span className="dark:text-dark-secondary-text text-onlight-text-3 truncate text-xs">
            {group.locationName}
          </span>
          <span className="dark:text-dark-secondary-text text-onlight-text-3 text-xs font-medium">
            {group.cameraCount}
          </span>
        </div>
      </div>
    </>
  );

  if (!onToggle) {
    return <div className={rowClassName}>{content}</div>;
  }
  return (
    <button
      type="button"
      onClick={onToggle}
      className={clsx(rowClassName, 'cursor-pointer', stateClassName(checked))}
    >
      {content}
    </button>
  );
}

export default MultiCamCameraGroupRow;
